import { t } from "@lingui/macro";

import { Input } from "@whoosh/design-system/src/components/controls";
import { SearchIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { VStack } from "@whoosh/design-system/src/components/primitive";

export const ClubSelectionSearchInput = ({
  value,
  setValue,
}: {
  value: string;
  setValue: (value: string) => void;
}) => {
  return (
    <VStack my={6} gap={6}>
      <Input<"text">
        name={"test input"}
        placeholder={t`Find a facility by name`}
        leftIcon={<SearchIcon color="inherit" />}
        size={"large"}
        hasError={false}
        isDisabled={false}
        value={value}
        onChange={(newValue) => setValue(newValue)}
      />
    </VStack>
  );
};
